export default [
  {
    name: 'CanalSettlement',
    path: 'canal/settlement',
    component: () => import(/* webpackChunkName: "canal" */ './Settlement.vue')
  },
  {
    name: 'CanalSettlementDetail',
    path: 'canal/settlement/detail',
    component: () =>
      import(/* webpackChunkName: "canal" */ './SettlementDetailList.vue')
  }
]
